<template>
  <div>
    <div class="mb-6 pb-6 border-b-2 border-grey-light flex flex-wrap items-center">
      <div>
        <h1 class="text-grey-darker text-xl font-semibold leading-normal uppercase">
          PropQual
        </h1>
      </div>
    </div>

    <loader v-if="!loaded" />

    <div v-else class="rounded-lg bg-white relative w-full py-8 px-4">
      <div class="max-w-lg mx-auto text-center">
        <h3 class="flex justify-center items-center mb-1 leading-none"><img src="/img/propqual-logo.png" width="32px" height="auto" class="mr-2" /> PropQual Registration</h3>
        <icon name="attention_circle" :center="false" class="mx-auto mb-1 w-32 h-32 text-grey" />
        <h3 class="text-center mb-4">Order Cancelled</h3>
        <p class="mb-6">Your PropQual order has been cancelled.</p>
        <router-link to="/propqual-registration" class="text-propqual-orange no-underline hover:underline">&lt; Start a new PropQual registration</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/http'
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      sessionId: null,
      loaded: false
    }
  },
  created () {
    this.sessionId = this.$route.query.session_id
    Promise.all([
      this.loadOrder()
    ]).then(() => {
      this.loaded = true
    }).catch((errors) => {
      this.displayToastNotification({
        type: 'warning',
        icon: 'fa-exclamation-triangle',
        title: 'Order Not Found',
        info: errors.response.data.message
      })
    })
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    loadOrder () {
      return api.post('propqual/orders/payment-cancelled', {
        session_id: this.sessionId
      }).then((response) => {
      })
    }
  }
}
</script>
